import { Title } from '@utriper/core-ui';

import Dashboard from './Dashboard';

const AdminHomePage = () => {
    return (
        <>
            <Title value={'Admin Panel'} />
            <Dashboard />
        </>
    );
};

AdminHomePage.displayName = 'AdminHomePage';

export default AdminHomePage;
